module.exports = __webpack_public_path__ + "media/Voice_Over.e9327ba1.mp3";